/**
 * 공지·FAQ 등록/수정 (/adm/notice/edit) — CKEditor(decoupled) 본문 + 대상(본사·지사·회원유형·업종) 고르기
 * ($j.Pages.Admin.NoticeEdit / body data-page-name="NoticeEdit")
 *
 * 옛 public/js/a-notice-edit.js 와 blade 인라인 스크립트를 합쳤다. 버튼은 data-ne / data-ne-add / data-ne-reset
 * 위임으로 부른다 — window 에 함수를 내놓지 않는다. 서버 값은 #page-data.
 */
export default class NoticeEdit {
    initialize() { initialize(); }
}

// 서버 값 (initialize 가 #page-data 에서 채운다)
let is_edit_mode = '0';
let is_hidden = '0';
let bonsa_json = {};
let gisa_json = {};
let content = '';
let editor = null;

function bindActions(){
    $('#mainholder')
        .on('change', '[data-ne-add]', function(){ add_str(this, Number(this.dataset.neAdd)); })
        .on('click', '[data-ne-reset]', function(e){ e.preventDefault(); resetAll(Number(this.dataset.neReset)); })
        .on('click', '#toggleHtmlBtn', toggleHtmlMode)
        .on('click', 'img[data-zoom]', function(){ $j.Ui.ZoomPhoto.open(this.dataset.zoom); })
        .on('click', '[data-ne]', function(){
            const a = this.dataset.ne;
            if (a === 'submit') submitForm();
            else if (a === 'list') goList();
            else if (a === 'delete') deleteNotice(Number(this.dataset.n));
        });
}

// 목록으로 이동
function goList(){
    location.href = '/adm/notice';
}

// 삭제 (/adm/ajax/notice/delete 는 g5_notices.num 을 받음)
function deleteNotice(noticeNum){
    if (!confirm('이 공지를 삭제할까요? 삭제 후 되돌릴 수 없습니다.')) return;
    $.post('/adm/ajax/notice/delete', { num: noticeNum }, function(res){
        if (res && res.result) {
            alert('삭제했습니다.');
            location.href = '/adm/notice';
        } else {
            alert((res && res.message) || '삭제에 실패했습니다.');
        }
    });
}
function initialize(){
    const d = JSON.parse(document.getElementById('page-data').textContent);
    is_edit_mode = d.isEditMode;
    is_hidden    = d.isHidden;
    bonsa_json   = d.bonsa;
    gisa_json    = d.gisa;
    content      = d.content;

    bindActions();

    $('#start_date,#end_date').mobiscroll().datepicker({
        controls: ['calendar'],
        dateFormat: 'YYYY-MM-DD',
        locale: mobiscroll.localeKo,
        buttons: [],  // 설정 버튼 제거
    });
    print_bonsa();
    print_gisa();
    print_type();
    print_cartype();
    initCarTypeSelect();

    if(is_edit_mode){
        if(is_hidden==1){
            $('[name="is_hidden"]').attr('checked',true);
        }
        initEditor();
    }
}

function initCarTypeSelect(){
    const $el = $('#cartype-select');
    $el.empty();
    $el.append('<option value="">업종선택</option>');
    $.each(G5['CARTYPE_KR'], function(index, v) {
        $el.append('<option value="' + v + '">' + v + '</option>');
    });
}

// 웹에디터 초기화
function initEditor(){
    DecoupledEditor
        .create(document.querySelector('#editor'), {
            toolbar: [
                'heading', '|',
                'fontSize', 'fontFamily', '|',
                'fontColor', 'fontBackgroundColor', '|',
                'bold', 'italic', 'strikethrough', 'underline', '|',
                'alignment', '|',
                // 'numberedList', 'bulletedList', '|',
                'indent', 'outdent', '|',
                'link', 'blockQuote', 'insertTable', '|',
                'undo', 'redo'
            ],
            language: 'ko'
        })
        .then(newEditor => {
            editor = newEditor;
            // 툴바를 에디터 위에 배치
            document.querySelector('.toolbar-container').appendChild(
                editor.ui.view.toolbar.element
            );
            // 기존 내용 설정
            editor.setData(content);
        })
        .catch(error => {
            console.error(error);
        });
}
/**
 * HTML 소스 편집 ↔ WYSIWYG 토글.
 * CKEditor 5 decoupled-document CDN 빌드는 sourceEditing 을 포함하지 않아서
 * textarea 로 대체 편집을 제공한다. 현재 모드 상태는 isHtmlMode 로 보관.
 */
let isHtmlMode = false;
function toggleHtmlMode(){
    const $editorBox  = $('#editor');
    const $toolbar    = $('.toolbar-container');
    const $htmlBox    = $('#htmlEditor');
    const $btn        = $('#toggleHtmlBtn');

    if (!isHtmlMode) {
        // WYSIWYG → HTML
        $htmlBox.val(editor ? editor.getData() : '');
        $editorBox.hide();
        $toolbar.hide();
        $htmlBox.show();
        $btn.text('에디터 편집');
        isHtmlMode = true;
    } else {
        // HTML → WYSIWYG
        if (editor) editor.setData($htmlBox.val());
        $htmlBox.hide();
        $editorBox.show();
        $toolbar.show();
        $btn.text('HTML 편집');
        isHtmlMode = false;
    }
}

// submit
function submitForm() {
    var m = document.inputform;
    if (m.evt_title.value == "") {
        alert("제목을 입력해 주세요");
        m.evt_title.focus();
        return
    }
    // HTML 모드면 textarea 값을 우선, 아니면 CKEditor 값을 사용
    m.evt_text.value = isHtmlMode ? $('#htmlEditor').val() : editor.getData();

    let formData = new FormData(m);
    $.ajax({
        type: "POST",
        url: `/adm/ajax/notice/save`,
        data: formData,
        processData: false,
        contentType: false,
        success: function (data) {
            if(!data.result){
                alert(data.message);
                return;
            }
            alert("저장되었습니다.");
            goList();   // 목록(/adm/notice)으로 — 예전엔 없어진 레거시 주소(/skw_1000.php)로 가서 404 였다
        }
    });
}



function resetAll(n) {
    if (n == 1) {
        $('#tar_bonsa').val('');
        print_bonsa();
    }
    else if (n == 2) {
        $('#tar_gisa').val('');
        print_gisa();
    }
    else if (n == 3) {
        $('#tar_type').val('');
        print_type();
    }
    else if (n == 4) {
        $('#tar_cartype').val('');
        print_cartype();
    }
}
function print_bonsa(){
    let arr = $('#tar_bonsa').val().split(',');
    let out = [];
    arr.forEach((v)=>{
        if(!v) return;
        out.push(bonsa_json[v]);
    });
    $('#bonsanum_str').val(out.toString());
}
function print_gisa(){
    let arr = $('#tar_gisa').val().split(',');
    let out = [];
    arr.forEach((v)=>{
        if(!v) return;
        out.push(gisa_json[v]);
    });
    $('#gisanum_str').val(out.toString());
}
function print_type(){
    let arr = $('#tar_type').val().split(',');
    let out = [];
    arr.forEach((v)=>{
        if(!v) return;
        out.push(v);
    });
    $('#mem_str').val(out.toString());
}
function print_cartype(){
    let arr = $('#tar_cartype').val().split(',');
    let out = [];
    arr.forEach((v)=>{
        if(!v) return;
        out.push(v);
    });
    $('#cartype_str').val(out.toString());
}

function add_str(obj, n) {
    var sstar = null;
    if (n == 1) {//본사
        sstar = "bonsanum_str";
    }
    if (n == 2) {//지사
        sstar = "gisanum_str";
    }
    if (n == 3) {
        sstar = "memtype_str";
    }
    if (n == 4) {
        sstar = "memgotype_str";
    }
    var objVal = obj.value;
    var objStr = obj.options[obj.selectedIndex].text;
    console.log(objVal + " / " + objStr);
    if (objVal.length < 1 || sstar == null) return;
    if (n == 1) {//본사
        let tar_bonsa = $('#tar_bonsa').val().split(',');
        tar_bonsa.indexOf(objVal) < 0 ? tar_bonsa.push(objVal) : tar_bonsa.splice(tar_bonsa.indexOf(objVal), 1);// 없으면 추가 , 있으면 삭제
        $('#tar_bonsa').val(tar_bonsa);
        print_bonsa();
    } else if (n == 2) {//지사
        let tar_gisa = $('#tar_gisa').val().split(',');
        tar_gisa.indexOf(objVal) < 0 ? tar_gisa.push(objVal) : tar_gisa.splice(tar_gisa.indexOf(objVal), 1);// 없으면 추가 , 있으면 삭제
        $('#tar_gisa').val(tar_gisa);
        print_gisa();
    } else if (n == 3) {
        let tar_type = $('#tar_type').val().split(',');
        tar_type.indexOf(objVal) < 0 ? tar_type.push(objVal) : tar_type.splice(tar_type.indexOf(objVal), 1);// 없으면 추가 , 있으면 삭제
        $('#tar_type').val(tar_type);
        print_type();
    } else if (n == 4) {
        console.log(objVal);
        let tar_cars = $('#cartype_str').val().split(',');
        tar_cars.indexOf(objVal) < 0 ? tar_cars.push(objVal) : tar_cars.splice(tar_cars.indexOf(objVal), 1);
        // tar_cars_str.indexOf(objStr) < 0 ? tar_cars_str.push(objStr) : tar_cars_str.splice(tar_cars_str
        //     .indexOf(objStr), 1);
        $('#tar_cartype').val(tar_cars);
        print_cartype();
        // show_contents(tar_cars, tar_cars_str, "memgotype_str");
    }
}

function show_contents(objs, objstrs, tar) {
    var ret = "";
    var sret = "";
    var hdds = tar + "_nums";
    console.log(objs, objstrs);
    for (var i = 0; i < objs.length; i++) {
        ret += objs[i];
        if (i + 1 < objs.length) ret += ",";
        sret += objstrs[i];
        if (i + 1 < objs.length) sret += ",";

    }
    console.log(tar);
    console.log(hdds);
    if (document.getElementById(hdds)) document.getElementById(hdds).value = ret;
    document.getElementById(tar).value = sret;
}
